import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PROJECT_STEP } from '../constants';
import { Get, Put } from '../../utils/httpProvider';
import { PROJECT_STEP_API } from '../../utils/apiUrl';

export const projectStepGetByProjectIdAction = createAsyncThunk(
  PROJECT_STEP.GET_BY_PROJECT,
  async (projectId, { rejectWithValue }) => {
    try {
      const data = await Get(PROJECT_STEP_API.BY_PROJECT(projectId), null, null);
      if (!data) {
        return rejectWithValue('Không lấy được danh sách bước dự án');
      }
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const projectStepUpdateStatusAction = createAsyncThunk(
  PROJECT_STEP.UPDATE,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await Put(
        PROJECT_STEP_API.UPDATE_STATUS, 
        `${id}/status`,
        data
      );

      if (res && typeof res.status === 'number') {
        if (res.status >= 200 && res.status < 300) {
          let body = null;
          try {
            body = await res.json();
          } catch (_) {}
          // body là ProjectStepDto
          return body || { id, ...data };
        }

        let errBody = null;
        try {
          errBody = await res.json();
        } catch (_) {}
        return rejectWithValue(
          errBody || 'Cập nhật trạng thái bước quy trình thất bại'
        );
      }

      if (!res)
        return rejectWithValue('Cập nhật trạng thái bước quy trình thất bại');

      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const projectStepSlice = createSlice({
  name: PROJECT_STEP.NAME_SLICE,
  initialState,
  reducers: {
    clearProjectStep(state) {
      state.items = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(projectStepGetByProjectIdAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(projectStepGetByProjectIdAction.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload || [];
      })
      .addCase(projectStepGetByProjectIdAction.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload ||
          action.error?.message ||
          'Đã xảy ra lỗi khi tải bước dự án';
      })

      .addCase(projectStepUpdateStatusAction.fulfilled, (state, action) => {
        const updated = action.payload;
        if (!updated || !updated.id) return;
        const idx = state.items.findIndex((x) => x.id === updated.id);
        if (idx >= 0) {
          state.items[idx] = {
            ...state.items[idx],
            status: updated.status,
          };
        }
      })
      .addCase(projectStepUpdateStatusAction.rejected, (state, action) => {
        state.error =
          action.payload ||
          action.error?.message ||
          'Cập nhật trạng thái bước quy trình thất bại';
      });
  },
});

export const { clearProjectStep } = projectStepSlice.actions;
export default projectStepSlice.reducer;
